import { defaulLangTextValidation, defaultTTranslate, SORTING_DIRECTION } from 'src/constants/main';
import {
  EXCLUSIONS_COLUMN_NAME,
  IExclusion,
  IExclusionsFilters,
  IExclusionValidation,
} from 'src/view/screens/MenuManagementScreen/screens/ExclusionsScreen/types/exclusions';

export const defaultExclusion: IExclusion = {
  id: 0,
  external_id: undefined,
  name: defaultTTranslate,
  status: 1,
  is_delete: 0,
  is_draft: true,
};

export const defaultExclusionsFilters: IExclusionsFilters = {
  search: '',
  availability: undefined,
  sort_field: EXCLUSIONS_COLUMN_NAME.NAME,
  sort_dir: SORTING_DIRECTION.ASCENDING,
};

export const defaultExclusionValidation: IExclusionValidation = {
  valid: true,
  name: defaulLangTextValidation,
};
